import { useAssignBagNumberToMadinaManifestMutation, useAssignBagNumberToMadinaTafweejMutation } from "@/services/arrivals/madinah/arrival.madinah";
import { useCreateAndAssignBagMutation } from "@/services/madinah/bag";
import { useSearchQuery } from "@/utils/hooks/useSearchQuery";

export const useAssignBag = ({ manifestId }) => {
    const [searchParams] = useSearchQuery();

    const { mutate: assignBagToManifest, isPending: isAssignBagNumberToMadinaManifestPending } = useAssignBagNumberToMadinaManifestMutation({ manifestId });
    const { mutate: assignBagToTafweej, isPending: isAssignBagNumberToMadinaTafweejPending } = useAssignBagNumberToMadinaTafweejMutation({ manifestId });
    const { mutate: createAndAssignBagToManifest, isPending: isCreateAndAssignBagPending } = useCreateAndAssignBagMutation({ manifestId });

    const isPending = isAssignBagNumberToMadinaManifestPending || isCreateAndAssignBagPending || isAssignBagNumberToMadinaTafweejPending;
    const assignBag = searchParams?.source === "between_cities" ? assignBagToTafweej : assignBagToManifest;
    const createAndAssignBag = createAndAssignBagToManifest;

    return {
        assignBag,
        createAndAssignBag,
        isPending
    }
}